<script setup lang="ts">
import {Customer} from "@/customer/interfaces/Customer";
import {PropType} from "vue";
import apodisWhiteLogo from '@/assets/images/logos/apodis-white.svg';
import CustomerCertificationDialog from "@/customer/components/customer-certification/CustomerCertificationDialog.vue";

const props = defineProps({
    customer: {
        type: Object as PropType<Customer>,
        required: true
    }
});

</script>

<template>
  <div>
    <CustomerCertificationDialog :customer="customer">
      <template #activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          class="w-max !rounded-2xl !normal-case px-6"
          color="primary"
          density="comfortable"
          prepend-icon="mdi-cellphone"
          :text="'Connecter ' + props.customer.information.first_name"
          variant="flat"
        >
          <template #prepend>
            <img :src="apodisWhiteLogo" alt="Apodis" class="h-4 w-4">
          </template>
        </v-btn>
      </template>
    </CustomerCertificationDialog>
  </div>
</template>
